import { commonPersonalInformationFields } from '../PersonalInformation/fields';

export default [...commonPersonalInformationFields].filter(
    (field) => field !== 'people[].addresses[].residential_status'
);
